import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { getSearchResultByTextAction } from '@/Module/Search/Store/Action/getSearchResultByTextAction';
import { searchResultLessonAdapter } from '@/Module/Search/Store/Adapter';

const SearchResultSlice = createSlice({
  name: 'searchResult',
  initialState: searchResultLessonAdapter.getInitialState({
    isLoading: true,
    page: 0,
    rows: 12,
    total: 0,
    sortOrder: 'NEWS',
    resetDate: 0,
  }),
  reducers: {
    nextPage: state => {
      state.page += 1;
    },
    setSortOrder: (state, { payload }) => {
      state.sortOrder = payload;
      state.page = 0;
    },
    setPage: (state, { payload }: PayloadAction<number>) => {
      state.page = payload;
    },

    resetSearch: state => {
      searchResultLessonAdapter.removeAll(state);
      state.page = 0;
      state.resetDate = Date.now();
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getSearchResultByTextAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getSearchResultByTextAction.rejected, state => {
        state.isLoading = true;
      })
      .addCase(getSearchResultByTextAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.total = payload.total;
        if (state.page === 0) {
          searchResultLessonAdapter.setAll(state, payload.data);
        } else {
          searchResultLessonAdapter.addMany(state, payload.data);
        }
      });
  },
});

export const {
  nextPage: searchResultLessonNextPageAction,
  setSortOrder: searchResultLessonSetSortOrderAction,
  resetSearch: searchResultLessonSetResetSearchAction,
} = SearchResultSlice.actions;
export default SearchResultSlice;
